export default {
  classTrans: 'Transférer de classe',
  classTransDiff: 'Transférer dans des classes avec des prix différents',
  actuallyPrice: 'Frais de cours (classe cible)',
  remainingFee: 'Frais de cours restants (classe actuelle)',
  refundTotal: 'Remboursement Total',
}
